"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bem = void 0;
var classnames_1 = __importDefault(require("classnames"));
var bem = function (base) {
    var mods = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        mods[_i - 1] = arguments[_i];
    }
    return (0, classnames_1.default)(base, mods.map(function (mod) { return (0, classnames_1.default)(mod)
        .split(' ')
        .filter(function (n) { return n; })
        .map(function (modifier) { return "".concat(base, "--").concat(modifier); }); }));
};
exports.bem = bem;
